<template>
  <v-list-item
    :to="item.to"
    :href="!item.to ? item.href : undefined"
    :target="item.href && item.href !== '#' ? '_blank' : undefined"
    :prepend-icon="showIcon ? item.icon : undefined"
    :title="item.title"
  />
</template>

<script>
  export default {
    name: 'BaseItem',
    props: {
      item: {
        type: Object,
        default: () => ({
          href: undefined,
          icon: undefined,
          title: undefined,
          to: undefined,
        }),
      },
      text: {
        type: Boolean,
        default: false,
      },
      showIcon: {
        type: Boolean,
        default: true,
      },
    },
  }
</script>
